import React, {FunctionComponent} from 'react';
import './Checkbox.less';

// @ts-ignore
import CheckIcon from 'new-images/check.svg';

interface CheckboxProps {
	isChecked: boolean,
	isSecondary?: boolean,
	isRadio?: boolean
}

export const Checkbox: FunctionComponent<CheckboxProps> = ({isChecked, isSecondary, isRadio}) => {
	return (
		<a
			className={`checkbox ${
				isChecked ? 'checkbox--checked' : ''
			} ${
				isRadio ? 'checkbox--radio' : ''
			} ${
				isSecondary ? 'checkbox--secondary' : ''
			}`}
			dangerouslySetInnerHTML={{
				__html: isChecked ? CheckIcon : null,
			}}
		></a>
	);
};
